<flowaccount-business-intro></flowaccount-business-intro>

<flowaccount-business-banner></flowaccount-business-banner>

<flowaccount-review-setion
  [bgColorTheme]="'blue-light-bg'"
  [customTextList]="{
    title: 'REVIEWS_PARTNERS_FLOWACCOUNT.TITLE',
    detail: 'REVIEWS_PARTNERS_FLOWACCOUNT.DETAIL',
    button: 'REVIEWS_PARTNERS_FLOWACCOUNT.BTN',
  }"
></flowaccount-review-setion>

<flowaccount-business-registration-testimonial></flowaccount-business-registration-testimonial>

<flowaccount-business-good-point
  [goodPointList]="goodPointList"
  [mockContent]="[
    {
      title: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.TITLE.DESKTOP',
      detail: 'BUSINESS_REGISTRATION.BUSINESS_SWIPER.TITLE.DETAIL',
    },
  ]"
></flowaccount-business-good-point>

<flowaccount-business-register-by-email></flowaccount-business-register-by-email>

<flowaccount-business-register-company></flowaccount-business-register-company>

<flowaccount-business-service></flowaccount-business-service>

<flowaccount-content-call-to-action-squidex
  [contentCTA]="'BUSINESS_REGISTRATION.CTA.HEADING'"
  [contentTextLink]="'BUSINESS_REGISTRATION.CTA.BTN'"
  [contentScully]="'CONTENT_CTA_BUSINESS_REGISTRATION'"
  [styleClass]="'business-registration'"
  [isBusinessRegistration]="true"
>
</flowaccount-content-call-to-action-squidex>

<flowaccount-business-register-online-by-yourself></flowaccount-business-register-online-by-yourself>

<flowaccount-blog-swiper-squidex
  [customHeader]="{
    heading: 'BLOG_SWIPER_TOPIC.HEADING_BUSINESS-REGISTRATION',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_BUSINESS-REGISTRATION',
  }"
  [contentSquidex]="'business-registration-blog'"
  [contentScully]="'business-registration-blog-key'"
></flowaccount-blog-swiper-squidex>

<flowaccount-starter-kit-shared></flowaccount-starter-kit-shared>

<flowaccount-faq-accordion-squidex
  [contentSquidex]="'business-registration-faq'"
  [contentScully]="'business-registration-faq-key'"
></flowaccount-faq-accordion-squidex>

<flowaccount-content-call-to-action-privilege
  [contentCTA_1]="'CONTENT_CTA_PRIVILEGE_BUSINESS-REGISTRATION.HEADING_1'"
  [contentCTA_2]="'CONTENT_CTA_PRIVILEGE_BUSINESS-REGISTRATION.HEADING_2'"
  [contentCTA_mobile]="'CONTENT_CTA_PRIVILEGE_BUSINESS-REGISTRATION.HEADING_MOBILE'"
  [contentTextLink]="'CONTENT_CTA_PRIVILEGE_BUSINESS-REGISTRATION.BUTTON_LINK'"
>
</flowaccount-content-call-to-action-privilege>
